/**
 * Default profile/sidebar avatar until the user uploads a photo.
 * Optional VITE_DEFAULT_PROFILE_AVATAR_URL; else VITE_LOGIN_BRAND_LOGO_URL; else /du-login-logo.png
 */
export function getDefaultUserAvatarUrl() {
  const explicit = import.meta.env.VITE_DEFAULT_PROFILE_AVATAR_URL;
  if (typeof explicit === "string" && explicit.trim() !== "")
    return explicit.trim();
  const brand = import.meta.env.VITE_LOGIN_BRAND_LOGO_URL;
  if (typeof brand === "string" && brand.trim() !== "") return brand.trim();
  return "/du-login-logo.png";
}
